import { render, staticRenderFns } from "./FacebookButtonComponent.vue?vue&type=template&id=d5cdabbe&scoped=true"
import script from "./FacebookButtonComponent.vue?vue&type=script&lang=js"
export * from "./FacebookButtonComponent.vue?vue&type=script&lang=js"
import style0 from "./FacebookButtonComponent.vue?vue&type=style&index=0&id=d5cdabbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cdabbe",
  null
  
)

export default component.exports